var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6659 14.4827C36.6659 16.466 36.3492 18.2993 35.7992 19.9993H4.19919C3.64919 18.2993 3.33252 16.466 3.33252 14.4827C3.33252 9.33268 7.48252 5.16602 12.5992 5.16602C15.6159 5.16602 18.3159 6.63268 19.9992 8.88268C21.6825 6.63268 24.3825 5.16602 27.3992 5.16602C32.5159 5.16602 36.6659 9.33268 36.6659 14.4827Z",
    fill: "#0D236E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.8007 20C33.1673 28.3333 25.0507 33.3167 21.034 34.6833C20.4674 34.8833 19.534 34.8833 18.9674 34.6833C14.9507 33.3167 6.83402 28.3333 4.20068 20H35.8007Z",
    fill: "#0D236E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.cf746fe31d06c0ceaef0e7dffd0dbd67.svg";
export { ForwardRef as ReactComponent };